<div [appLoadingAnimation]="loading" class="loader"></div>
